import { Info } from 'lucide-react';
import type { ReportSummaryItem } from '../../../../types/reports';
import { formatCurrency } from '../reportFormat';

export function SummaryCard({ item }: { item: ReportSummaryItem }) {
  let display: string;
  if (item.format === 'currency') {
    const amount = Number(item.value);
    display = Number.isFinite(amount) ? formatCurrency(amount) : String(item.value);
  } else if (item.format === 'number') {
    const amount = Number(item.value);
    display = Number.isFinite(amount) ? amount.toLocaleString('en-US') : String(item.value);
  } else if (item.format === 'percent') {
    const amount = Number(item.value);
    display = Number.isFinite(amount) ? `${amount.toLocaleString('en-US')}%` : String(item.value);
  } else display = String(item.value);

  return (
    <div
      className="rounded-xl border border-border bg-gradient-to-br from-surface to-background/40 p-3.5 shadow-sm transition-shadow hover:shadow-md"
      title={item.hint}
    >
      <p className="flex items-center gap-1 text-[0.625rem] font-semibold uppercase tracking-wider text-text-muted">
        <span>{item.label}</span>
        {item.hint && (
          <Info
            size={11}
            className="shrink-0 cursor-help text-text-muted/70"
            aria-label={item.hint}
          />
        )}
      </p>
      <p className="mt-1 text-lg font-bold tabular-nums text-text break-words">{display}</p>
    </div>
  );
}
